/**
 * 个位数补0
 *  5 => 05
 * @param {number} number 需要转换的数字
 * @returns {number|string}
 */
 export const formatNumber = (number) => {
    number = number.toString()
    return number[1] ? number : '0' + number
  }


// export const priceSeparator = (num) => {
//   num = num ? num : ''
//   let numSplit = String(num).split('.')
//   return numSplit[0].replace(/(\d)(?=(?:\d{3})+$)/g,'$1,') + '.' + (numSplit[1]?numSplit[1]:'00')
// }

export const priceSeparator = (num) => {
  let numSplit = String(num).split('.')
  // if(isInt){
  //     return numSplit[0].replace(/(\d)(?=(?:\d{3})+$)/g,'$1,')
  return numSplit[0].replace(/(\d)(?=(?:\d{3})+$)/g,'$1,') + '.' + (numSplit[1] === undefined? '00': (numSplit[1]+'0').slice(0,2))
}

// 人数大于5位数，展示为XX.XX万人
export const transPeople = (num) => {
  const numStr = String(num || 0)
  let newNum = num || 0;
  if (numStr && numStr.length >= 4) {
      newNum = Math.round(num / 100)/10
      newNum += 'k'
  }
  return newNum
}